import { render, staticRenderFns } from "./consumptionCarouselItem.vue?vue&type=template&id=47a7f130&scoped=true&"
import script from "./consumptionCarouselItem.vue?vue&type=script&lang=js&"
export * from "./consumptionCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./consumptionCarouselItem.vue?vue&type=style&index=0&id=47a7f130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a7f130",
  null
  
)

export default component.exports